<template>
    <div>
       <!-- <div class="header-badFood" :style="{ backgroundImage: 'url(' + images.insideShop + ')' }">
        </div>-->
        <div class="contact-badFood">
            <div class="firstPara-container">
                <div class="first-paragraph-badFood">
                    <p>Świat nam współczesny jest światem pełnym sprzeczności i wzajemnie wykluczających się postaw. Każdy z nas wie, że to co spożywamy i to co nas otacza ma decydujący wpływ na nasze samopoczucie, na nasze zdrowie, w efekcie końcowym na jakość i długość przebywania na naszej pięknej planecie. </p>
                    <p class="blue">Podziel się z nami swoimi doświadczeniami tymi dobrymi,</p>
                    <p class="blue">jak i tymi niezbyt przyjemnymi, złymi.</p>
                </div>
            </div>
                <router-link to="/contact">
                        <div class="contact-box">
                            <img :src="images.envelope"/>
                            <p><span class="quiteBig">Opisz nam</span><br/>co Cię spotkało</p>
                        </div>
                </router-link>
        </div>
        <div class="badFood-container">
            <div class="left-container">
                <div class="text-container">
                    <div class="text-container1">
                    <p class="cursive">Hasła jedz zdrowo i dbaj o środowisko towarzyszą nam praktycznie wszędzie,
                    każdego dnia i zdaje się od że zawsze,
                    a już na pewno od kilku dekad.</p>
                    <p> Zdecydowana większość z nas zmieniła i w dalszym ciągu zmienia swoje nawyki żywieniowe,
                    nie zapominając przy tym chociażby o segregacji śmieci, wymianie na bardziej ekologiczne pieców grzewczych
                    czy zakupie elektrycznych samochodów. Naukowcy opracowują coraz to nowe sposoby walki z
                    chorobami, chirurgia zaskakuje nas coraz to nowymi możliwościami przeprowadzania zabiegów, a cały sztab dietetyków głowi
                    się nad nowymi, bardziej wysublimowanymi zestawami żywieniowymi.</p>
                    <p> Patrząc przez ten pryzmat, wydaje się, że
                    zmierzamy razem, wszyscy w jednym, jedynie słusznym kierunku, jakim jest dbałość o zdrową przyszłość naszą i naszej
                     planety Ziemia. Pomimo przebytych wielu kilometrów na tej drodze i odniesienia
                      wielu spektakularnych sukcesów, obawiam się, że często zapominamy o jakże ważnej sprawie: co kupujemy i w efekcie końcowym
                      co jemy oraz czym karmimy nasze pociechy - przyszłe pokolenia.</p></div>
                </div>
            </div>
            <div class="ecologyImg-container" :style="{ backgroundImage: 'url(' + images.ekologia + ')' }">
            </div>
        </div>
        <div class="badFood-container1">
            <div class="ecologyImg-container1">
                <img class="vege" :src="images.vegetables" alt="vegetables"/>
            </div>
            <div class="right-container">
                <div class="summary">
                    <div class="summary1">
                        <p class="cursive1">MATERIAŁY TWORZONE DLA WAS I PRZEZ WAS</p>
                        <p>Chcemy sprawdzić, czy przekaz zgadza się z rzeczywistością. Czy aby na pewno pod pachnącą szynką i wypieczonym, uśmiechającym się do nas pieczywem kryje się dobry produkt. Czy oferowane nam marchewki, jabłka, pomidory, cytrusy, mięso, nabiał, soki itp. są zawsze świeże i warte zakupu. Czy usługi są na odpowiednim poziomie, czy gastronomia się broni, czy jest fachowo, przyjemnie i po prostu czysto, czy zakres usług jest zgodny z przedstawioną nam ofertą. Słowem, czy dostępne szeroko rozumiane produkty to po prostu samo zdrowie, gdzie to zdrowie jest ewentualnie do kupienia i czy zdrowie to, jest warte ceny, którą musimy za nie zapłacić.</p>
                        <p class="bigger-bold"><strong>Zapraszamy do lektury</strong></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="exapmles-container">
            <div class="bad-examples-container">
                <div class="badfood-box">
                    <div class="img-container" :style="{ backgroundImage: 'url(' + images.splesniale_mandarynki + ')' }">
                    </div>
                    <div class="bad-desc-box">
                        <h4>Mandarynki</h4>
                        <p>{{ descriptionMandarynki }}</p>
                        <p class="read-more"  @click="showFullTextMandarynki = !showFullTextMandarynki"> Czytaj {{ showFullTextMandarynki ? "mniej" : "więcej" }}</p>
                    </div>
                </div>
                <div class="badfood-box">
                    <div class="img-container" :style="{ backgroundImage: 'url(' + images.bad_floor + ')' }">
                    </div>
                    <div class="bad-desc-box">
                        <h4>Wypoczynek</h4>
                        <p>{{ descriptionWypoczynek }}</p>
                        <p class="read-more"  @click="showFullTextWypoczynek = !showFullTextWypoczynek"> Czytaj {{ showFullTextWypoczynek ? "mniej" : "więcej" }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import insideShop from '../photos/shopInside.jpeg';
import leaf from '../photos/leaf.png';
import ekologia from '../photos/EkologiaMendelHelps.jpeg';
import vegetables from '../photos/vege.png';
import splesniale_mandarynki from '../photos/zle_mandarynki.jpeg';
import bad_floor from '../photos/bad_floor.jpeg';
import envelope from "../photos/envelope.png";
export default {
    data() {
            return {
                images: {
                    insideShop: insideShop,
                    leaf: leaf,
                    ekologia: ekologia,
                    vegetables: vegetables,
                    splesniale_mandarynki: splesniale_mandarynki,
                    bad_floor: bad_floor,
                    envelope: envelope
                },
                showFullText: false,
                showFullTextMandarynki: false,
                showFullTextWypoczynek: false,
                descMandarynki: 'Jakże często produkty o jakości widocznej na zdjęciu spotykam na swojej drodze, dokonując zakupów w jednej z największych sieci detalicznych w Polsce. Mandarynki, winogrona, pomidory, rzodkiewki spleśniałe, nadgnite, zwiędnięte, wysuszone słowem nie nadające się do spożycia, to obraz, który towarzyszy mi praktycznie permanentnie. Czy fakt ten oznacza, że wszyscy przywykliśmy do tego widoku, do takiego traktowania nas, klientów? Czy też mamy do czynienia z powszechnym przyzwoleniem na taki stan rzeczy, gdyż nie widzimy szans na zmianę? Nie może i nie powinno być zgody, aby ktokolwiek i gdziekolwiek oferował nam sprzedaż wiązaną polegającą na zakupie owoców lub warzyw wraz z pleśnią lub z towarzystwem pleśni. I nie chodzi tutaj tylko o względy estetyczne. Najważniejsze są względy zdrowotne. Żywność, na której zauważymy pleśń, powinna zostać wyrzucona i nie powinna być spożywane przez ludzi, a tym samym oferowana do zakupu. Pomimo usunięcie nalotu pleśni z powierzchni owocu, warzywa pozostaje w nich grzybnia i niebezpieczne związki, w tym toksyczne dla ludzi mikotoksyny. Nie dajmy się, walczmy o dobrą jakość oferowanych nam produktów i tym samym o nasze zdrowie. Jesteśmy i będziemy w tym pomocni, piętnując przypadki niedbalstwa, braku rzetelności i dbałości o nasze wspólne dobro, jakim jest nasze zdrowie. Pamiętajcie – Zawsze, kiedy potrzebujesz pomocy… Mendel Helps.',
                descWypoczynek: 'Wyjeżdżając na wypoczynek, czy podreperować zdrowie, na wakacje, czy służbowo, mając możliwość wyboru, zawsze staramy się zapewnić swoim najbliższym, sobie optymalne warunki pobytu. Dokładnie śledzimy zamieszczone opinie na specjalistycznych portalach. Wybieramy te polecane lub te z największą ilością najlepszych ocen, pozytywnych opinii, gwiazdek. Dokładamy wszelkich starań, aby czas spędzony poza domem, był czasem miłym, także pod względem lokalowym. Działania o podobnym schemacie stały się ostatnio moim udziałem. Postąpiłem zgodnie z instrukcją, ale jak to zawsze w moim przypadku, z przysłowiowym sercem na ramieniu zmierzałem do miejsca docelowego, martwiąc się od startu co zastanę na miejscu. Piękny ośrodek, widoki, miła obsługa. Pozostał ostatni akt pierwszych chwil w miejscu docelowym, a mianowicie pokój hotelowy. Otwieram drzwi, czysto, klimatyzacja, czysta pościel, chyba będzie dobrze. Otwieram łazienkę, a w niej niezamawiany przeze mnie przyjaciel, często spotykany w niedomytych, niewietrzonych tego typu pomieszczeniach, przyjaciel zwany grzybem. Pierwszym tekstem nie będę wskazywał miejsca, chociażby z uwagi na naprawdę miłą i sympatyczną obsługę, która robiła wszystko, aby usunąć problem. Proszę, jednakże pamiętać, że tekstem tym chcę wszystkim oferujące szeroko rozumiane usługi zakomunikować jedno ważne przesłanie. Będziemy napiętnować z całą stanowczością brak utrzymania standardów, brak jakości i profesjonalizmu, będziemy wraz z naszymi Użytkownikami ganić wszystko to co złe i chwalić wszystko to co dobre. Nie ma przyzwolenia na bylejakość, za którą musimy płacić nasze tak trudno zarobione pieniądze. Robimy to dla nas, dla Was, dla wszystkich którym na sercu leży zdrowie własne i swoich najbliższych. Prosimy, nie zapominajcie: Zawsze, kiedy potrzebujesz pomocy … Mendel Helps i czekamy na Wasze udokumentowane doświadczenia.'
            }
        },
        computed: {
            descriptionMandarynki() {
                 if (this.showFullTextMandarynki) {
                return this.descMandarynki;
                }
                return `${this.descMandarynki.slice(0, 350).trim()}...`;
            },
            descriptionWypoczynek() {
                 if (this.showFullTextWypoczynek) {
                return this.descWypoczynek;
                }
                return `${this.descWypoczynek.slice(0, 350).trim()}...`;
            }
    },
}
</script>
<style scoped>
    .header-badFood {
        height: 350px;
        background-size: cover;
        background-position: center;
        margin-bottom: 80px;
        margin-top: -30px;
    }
    .contact-badFood {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    h3 {
        font-size: 40px;
    margin: 0;
    color: #3084E2;
    font-weight: 600;
    }
    .blue {
        margin: 15px 0;
        font-size: 32px;
        color: #3084E2;
        font-style: normal;
        line-height: 1.2;
    }
    .firstPara-container {
        width: 1450px;
        margin: 0 auto;
    }
    .first-paragraph-badFood {
        width: 100%;
        text-align: center;
        margin: 30px auto 30px auto;
        font-style: italic;
        font-weight: 500;
        line-height: 23px;
    }
    .first-paragraph-badFood p{
        margin: 20px 0;
    }
    .contact-box {
    width: 250px;
    height: 140px;
    background-color: #fff;
    padding: 20px;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    font-size: 16px;
    border-radius:20px;
    transition: 0.3s ease-out;
    box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.45) 0px 8px 32px;
}
.contact-box:hover {
    transform: scale(1.1);
}
.contact-box p {
    margin: 0;
    padding: 0;
    font-size: 18px;
}
.contact-box .quiteBig {
    font-size: 26px;
    font-weight: 600;
}
.contact-box img {
    width: 100px;
}
    .contact-box:hover {
        transform: scale(1.1);
        cursor: pointer;
    }
    .contact-box h4 {
        text-decoration: none;
        color: #333333;
    }
    a:link {
        text-decoration: none;
        color: #333333;
    }
    a:visited {
        text-decoration: none;
        color: #333333;
    }
    a:hover {
        text-decoration: none;
        color: #333333;
    }
    a:active {
    text-decoration: none;
        color: #333333;
    }
    .badFood-container, .badFood-container1 {
        display: flex;
        flex-direction: row;
        width: 1450px;
        margin: 30px auto 30px auto;
        margin-bottom: 80px;
    }
    .badFood-container1 {
        justify-content: center;
        align-items: center;
        width: 1450px;
    }
    .right-container {
        width: 50%;
        display:flex;
        justify-content: flex-start;
        align-items: center;
    }
    .badFood-container div {
        width: 50%;
        display:flex;
        justify-content: center;
        align-items: flex-end;
    }
    .ecologyImg-container {
        background-size: cover;
        background-position: left;
        border-radius: 0 30px 30px 0;
    }
    .ecologyImg-container1 {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .vege {
        width: 600px;
        padding: 30px;
    }
    .left-container {
        background-color: #9abc4c;
        padding: 30px 0;
        border-radius: 30px 0 0 30px;
        line-height: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .right-container {
        padding: 30px 0;
        line-height: 25px;
    }
    .text-container {
        padding: 30px;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .summary {
        padding: 30px;
    }
    .summary {
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .text-container1 {
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .summary1 {
        display:flex;
        flex-direction: column;
        justify-content: center;
        text-align: justify;
    }
    .text-container p {
        width: 600px;
        text-align: justify;
        margin: 10px;
        font-weight: 500;
    }
    .summary1 p{
        width: 600px;
        text-align: justify;
        margin: 10px;
        font-weight: 500;
    }
    .cursive {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
    }
    .cursive1 {
        font-weight: 500;
        font-size: 21px;
        color: #3084E2;
    }
    .bigger-bold {
        font-size: 18px;
    }
    .exapmles-container {
        display: flex;
        flex-direction: row;
        align-items: space-between;
        justify-content: center;
        margin: 50px auto;
        width:1450px;
    }
    .bad-examples-container {
        width: 1450px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .badfood-box {
        width: 700px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-color: #3084E2;
        border-radius: 20px;
        transition: 0.3s ease-out;
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.75) 0px 8px 32px;
    }
    .badfood-box:hover {
        transform: scale(1.1);
    }
    .img-container {
        height: 230px;
        width: 230px;
        background-size: cover;
        background-position: center;
        margin: 10px;
        border-radius: 20px;
        border: none;
    }
    .bad-desc-box {
        width: 500px;
        margin: 10px;
        height: 100%;
    }
    .bad-desc-box p{
        color: white;
        text-align: justify;
        font-size: 15px;
    }
    .bad-desc-box h4 {
        color: black;
        font-size: 25px;
        font-weight: 500;
        margin: 10px 10px 0 0;
    }
   .read-more {
        font-weight: 500;
        font-size: 15px;
   }
   .read-more:hover {
        cursor: pointer;
   }
  .envelope-text-container {
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
   }
   .envelope {
    width: 70px;
    margin-left: 10px;
    display: inline-block;
    transition: .5s ease-out;
   }
   .envelope:hover {
    cursor:pointer;
    transform: scale(1.1);
   }
@media only screen and (min-width: 1201px) and (max-width: 1450px) {
    .firstPara-container {
        box-sizing: border-box;
        width: 1200px;
        padding: 10px;
    }
    .blue {
        font-size: 20px;
    }
    .contact-box {
        box-sizing: border-box;
        width: 300px;
        padding: 10px;
    }
    .contact-box h4 {
        margin: 10px auto;
        font-size: 18px;
    }
    .container {
        width: 100vw;
    }
    .first-paragraph-badFood{
        width: 100%;
        text-align: justify;
    }
    .first-paragraph-badFood p {
        width: 100%;
    }

.header-badFood {
        height: 350px;
        margin-bottom: 50px;
        margin-top: -30px;
    }
    h3 {
        font-size: 40px;
    margin: 0;
    color: #3084E2;
    font-weight: 600;
    }
    .icon {
        width: 100px;
        margin: 20px;
    }
    .badFood-container, .badFood-container1 {
        display: flex;
        flex-direction: row;
        width:100%;
        margin-bottom: 80px;
    }
    .badFood-container1 {
        width:1200px;
        justify-content: center;
        align-items: center;
    }
    .right-container {
        width: 50%;
        display:flex;
        justify-content: flex-start;
        align-items: center;
    }
    .badFood-container div {
        width: 100%;
        display:flex;
        justify-content: center;
        align-items: flex-end;
    }
    .ecologyImg-container {
        background-size: cover;
        background-position: left;
        border-radius: 0 30px 30px 0;
    }
    .ecologyImg-container1 {
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .vege {
        width: 400px;
        padding: 20px;
    }
    .left-container {
        background-color: #9abc4c;
        padding: 30px 0;
        border-radius: 30px 0 0 30px;
        line-height: 25px;
    }
    .right-container {
        width: 100%;
        padding: 30px 0;
        line-height: 25px;
    }
    .text-container, .summary {
        padding: 30px;
    }
    .summary {
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
    }
    .summary1 {
        width: 100%;
    }
    .text-container p {
        width: 725px;
        text-align: justify;
        margin: 10px;
        font-weight: 500;
    }
    .summary1 p{
        width: 600px;
        text-align: center;
        margin: 10px;
        font-weight: 500;
    }
    .cursive {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
    }
    .cursive1 {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
        color: #3084E2;
    }
    .exapmles-container {
        display: flex;
        flex-direction: row;
        align-items: space-between;
        justify-content: center;
        margin: 50px auto;
        width:1200px;
    }
    .bad-examples-container {
        width: 1200px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .badfood-box {
        width: 550px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-radius: 20px;
        transition: 0.3s ease-out;
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.75) 0px 8px 32px;
    }
    .badfood-box:hover {
        transform: scale(1.1);
    }
    .img-container {
        height: 230px;
        width: 230px;
        background-size: cover;
        background-position: center;
        margin: 10px;
        border-radius: 20px;
        border: none;
    }
    .bad-desc-box {
        width: 500px;
        margin: 10px;
        height: 100%;
    }
    .bad-desc-box p{
        text-align: justify;
        font-size: 15px;
    }
    .bad-desc-box h4 {
        font-size: 25px;
        font-weight: 500;
        margin: 10px 10px 0 0;
    }
   .read-more {
        font-weight: 500;
        font-size: 15px;
   }
   .read-more:hover {
        cursor: pointer;
   }
}
@media only screen and (min-width: 901px) and (max-width: 1200px) {
    .firstPara-container {
        box-sizing: border-box;
        width: 900px;
        padding: 10px;
    }
    .blue {
        font-size: 20px;
    }
    .contact-box {
        box-sizing: border-box;
        width: 300px;
        padding: 10px;
    }
    .contact-box h4 {
        margin: 10px auto;
        font-size: 18px;
    }
    .container {
        width: 100vw;
    }
    .first-paragraph-badFood{
        width: 100%;
        text-align: justify;
    }
    .first-paragraph-badFood p {
        width: 100%;
    }

.header-badFood {
        height: 350px;
        margin-bottom: 50px;
        margin-top: -30px;
    }
    .first-paragraph {
        width: 900px;
    }
    h3 {
        font-size: 40px;
    margin: 0;
    color: #3084E2;
    font-weight: 600;
    }
    .icon {
        width: 100px;
        margin: 20px;
    }
    .badFood-container, .badFood-container1 {
        display: flex;
        flex-direction: row;
        width:100%;
        margin-bottom: 30px;
    }
    .badFood-container1 {
        width:900px;
        justify-content: center;
        align-items: center;
    }
    .right-container {
        width: 50%;
        display:flex;
        justify-content: flex-start;
        align-items: center;
    }
    .badFood-container div {
        width: 100%;
        display:flex;
        justify-content: center;
        align-items: flex-end;
    }
    .ecologyImg-container {
        background-size: cover;
        background-position: left;
        border-radius: 0 30px 30px 0;
    }
    .ecologyImg-container1 {
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .vege {
        width: 400px;
        padding: 20px;
    }
    .left-container {
        background-color: #9abc4c;
        padding: 30px 0;
        border-radius: 30px 0 0 30px;
        line-height: 25px;
    }
    .right-container {
        width: 100%;
        padding: 30px 0;
        line-height: 25px;
    }
    .text-container, .summary {
        padding: 10px;
    }
    .summary {
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 50%;
    }
    .summary1 {
        width: 50%;
    }
    .text-container p {
        width: 725px;
        text-align: justify;
        margin: 10px;
        font-weight: 500;
    }
    .summary1 p{
        width: 300px;
        text-align: center;
        margin: 10px;
        font-weight: 500;
    }
    .cursive {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
    }
    .cursive1 {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
        color: #3084E2;
    }
    .exapmles-container {
        display: flex;
        flex-direction: row;
        align-items: space-between;
        justify-content: center;
        margin: 30px auto;
        width:600px;
    }
    .bad-examples-container {
        width: 600px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
    .badfood-box {
        width: 100%;
        margin: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-radius: 20px;
        transition: 0.3s ease-out;
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.75) 0px 8px 32px;
    }
    .badfood-box:hover {
        transform: scale(1.1);
    }
    .img-container {
        height: 230px;
        width: 230px;
        background-size: cover;
        background-position: center;
        margin: 10px;
        border-radius: 20px;
        border: none;
    }
    .bad-desc-box {
        width: 600px;
        margin: 10px;
        height: 100%;
    }
    .bad-desc-box p{
        text-align: justify;
        font-size: 15px;
    }
    .bad-desc-box h4 {
        font-size: 25px;
        font-weight: 500;
        margin: 10px 10px 0 0;
    }
   .read-more {
        font-weight: 500;
        font-size: 15px;
   }
   .read-more:hover {
        cursor: pointer;
   }

   .blue-background {
    width: 900px;
    margin: 20px 0 0 0;
    background-image: linear-gradient(to right, #5D4DB7 , #3084E2);
    border-radius: 25px;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
   }
}
@media only screen and (min-width: 601px) and (max-width: 900px) {
    .firstPara-container {
        margin: 0 auto;
        box-sizing: border-box;
        width: 600px;
        padding: 10px;
    }
    .blue {
        font-size: 20px;
    }
    .contact-box {
        box-sizing: border-box;
        width: 300px;
        padding: 10px;
    }
    .contact-box h4 {
        margin: 10px auto;
        font-size: 18px;
    }
    .container {
        width: 100vw;
    }
    .first-paragraph-badFood{
        width: 100%;
        text-align: justify;
    }
    .first-paragraph-badFood p {
        width: 100%;
    }

.header-badFood {
        height: 200px;
        margin-bottom: 50px;
        margin-top: -30px;
    }
.first-paragraph-badFood {
        width: 100%;
    }
    h3 {
    width: 100%;
    font-size: 25px;
    margin: 0;
    color: #3084E2;
    font-weight: 600;
    }
    .icon {
        width: 100px;
        margin: 20px;
    }
    .badFood-container, .badFood-container1 {
        display: flex;
        flex-direction: row;
        width:580px;
        margin: 0 auto;
        margin-bottom: 80px;
    }
    .badFood-container1 {
        width:600px;
        justify-content: center;
        align-items: center;
    }
    .right-container {
        width: 30%;
        display:flex;
        justify-content: flex-start;
        align-items: center;
    }
    .badFood-container div {
        width: 100%;
        box-sizing: border-box;
        display:flex;
        justify-content: center;
        align-items: flex-end;
    }
    .ecologyImg-container {
        background-size: cover;
        background-position: left;
        border-radius: 0 20px 20px 0;
    }
    .ecologyImg-container1 {
        width: 30%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .vege {
        width: 200px;
        padding: 10px;
    }
    .left-container {
        width: 100%;
        background-color: #9abc4c;
        padding: 20px 0;
        border-radius: 30px 0 0 20px;
        line-height: 25px;
    }
    .right-container {
        width: 100%;
        padding: 10px 0;
        line-height: 25px;
    }
    .text-container, .summary {
        padding: 10px;
    }
    .summary {
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 300px;
    }
    .summary1 {
        width: 300px;
    }
    .text-container p {
        width:500px;
        text-align: justify;
        margin: 10px auto;
        font-weight: 500;
    }
    .text-container1 {
        width:100px;
        margin: 0 auto;
    }
    .summary1 p{
        width: 300px;
        text-align: justify;
        margin: 10px;
        font-weight: 500;
    }
    .cursive {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
    }
    .cursive1 {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
        color: #3084E2;
    }
    .exapmles-container {
        display: flex;
        flex-direction: row;
        align-items: space-between;
        justify-content: center;
        margin: 50px auto;
        width:600px;
    }
    .bad-examples-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
    .badfood-box {
        width: 100%;
        margin: 20px auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-radius: 20px;
        transition: 0.3s ease-out;
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.75) 0px 8px 32px;
    }
    .badfood-box:hover {
        transform: scale(1.1);
    }
    .img-container {
        height: 230px;
        width: 230px;
        background-size: cover;
        background-position: center;
        margin: 10px;
        border-radius: 20px;
        border: none;
    }
    .bad-desc-box {
        width: 100%;
        margin: 30px;
        height: 100%;
    }
    .bad-desc-box p{
        text-align: justify;
        font-size: 15px;
    }
    .bad-desc-box h4 {
        font-size: 25px;
        font-weight: 500;
        margin: 10px 10px 0 0;
    }
   .read-more {
        font-weight: 500;
        font-size: 15px;
   }
   .read-more:hover {
        cursor: pointer;
   }
   .blue-background-container {
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin:0;
    padding: 0;
   }
   .blue-background {
    width: 600px;
    margin: 20px 0 0 0;
    background-image: linear-gradient(to right, #5D4DB7 , #3084E2);
    border-radius: 25px;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
   }
    .blue-background div {
    font-size: 19px;
    color: white;
    font-weight: 500;
    margin: 50px 50px 10px 50px;
   }
   .blue-background div p {
    font-size: 18px;
    line-height: 1.3;
    font-weight: 400;
    text-align: justify;
   }
   .blue-background div .bigger-black {
    font-size: 32px;
    color: #272c33;
    font-weight: 600;
    font-size: 23px;
    text-align: center;
    display: inline-block;
   }
   .envelope-text-container {
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
   }
   .envelope {
    width: 70px;
    margin-left: 10px;
    display: inline-block;
    transition: .5s ease-out;
   }
}
@media only screen and (max-width: 600px) {
    .firstPara-container {
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
    }
    .blue {
        font-size: 20px;
    }
    .contact-box {
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
    }
    .contact-box h4 {
        margin: 10px auto;
        font-size: 18px;
    }
    .container {
        width: 100%;
        box-sizing: border-box;
    }
    .first-paragraph-badFood{
        width: 100%;
        box-sizing: border-box;
        text-align: justify;
    }
    .first-paragraph-badFood p {
        width: 100%;
    }
    h3 {
    width: 100%;
    font-size: 25px;
    margin: 0;
    color: #3084E2;
    font-weight: 600;
    }
    .icon {
        width: 100px;
        margin: 20px;
    }
    .badFood-container, .badFood-container1 {
        display: flex;
        flex-direction: column;
        width:100%;
        box-sizing: border-box;
        margin: 0 auto;
        margin-bottom: 30px;
    }
    .badFood-container1 {
        width:100%;
        padding: 10px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
    }
    .badFood-container div {
        width: 100%;
        box-sizing: border-box;
        display:flex;
        justify-content: center;
        align-items: flex-end;
    }
    .ecologyImg-container {
        background-size: cover;
        background-position: left;
        border-radius: 0 20px 20px 0;
        height: 200px;
        width: 100%;
        box-sizing: border-box;
    }
    .ecologyImg-container1 {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .vege {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
    }
    .left-container {
        box-sizing: border-box;
        width: 100%;
        background-color: #9abc4c;
        padding: 20px 0;
        border-radius: 30px 0 0 20px;
        line-height: 25px;
    }
    .right-container {
        box-sizing: border-box;
        width: 100%;
        line-height: 25px;
    }
    .text-container, .summary {
        box-sizing: border-box;
        width: 100%;
        box-sizing: border-box;
    }
    .summary {
        display:flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        box-sizing: border-box;
        padding: 0;
    }
    .summary1 {
        width: 100%;
        box-sizing: border-box;
    }
    .text-container p {
        width:100%;
        text-align: justify;
        margin: 10px auto;
        font-weight: 500;
    }
    .text-container1 {
        box-sizing: border-box;
        width:100%;
        box-sizing: border-box;
        margin: 0 auto;
    }
    .text-container1 p {
        width: 100%;
    }
    .summary1 p{
        width: 100%;
        text-align: justify;
        margin: 0 auto;
        font-weight: 500;
    }
    .cursive {
        font-style: italic;
        font-weight: 600;
        font-size: 20px;
    }
    .cursive1 {
        font-style: italic;
        font-weight: 600;
        font-size: 21px;
        color: #3084E2;
    }
    .exapmles-container {
        display: flex;
        flex-direction: row;
        align-items: space-between;
        justify-content: center;
        margin: 50px auto;
        width:100%;
        box-sizing: border-box;
    }
    .bad-examples-container {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
    .badfood-box {
        width: 100%;
        box-sizing: border-box;
        height: auto;
        margin: 20px auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        border-radius: 20px;
        transition: 0.3s ease-out;
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.75) 0px 8px 32px;
    }
    .badfood-box:hover {
        transform: none;
    }
    .img-container {
        height: 230px;
        width: 90%;
        box-sizing: border-box;
        background-size: cover;
        background-position: center;
        margin: 10px;
        border-radius: 20px;
        border: none;
    }
    .bad-desc-box {
        width: 100%;
        margin: 30px;
        padding: 10px;
        height: auto;
    }
    .bad-desc-box p{
        text-align: justify;
        font-size: 15px;
        margin: 10px;
    }
    .bad-desc-box h4 {
        font-size: 25px;
        font-weight: 500;
        margin: 10px 10px 0 0;
    }
   .read-more {
        font-weight: 500;
        font-size: 15px;
   }
   .read-more:hover {
        cursor: pointer;
   }
   .blue-background-container {
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    margin:0;
    padding: 0;
   }
   .envelope-text-container {
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
   }
   .envelope {
    width: 70px;
    margin-left: 10px;
    display: inline-block;
    transition: .5s ease-out;
   }
}
</style>